export const linksStyle = () => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 1.5,
  '& a': {
    lineHeight: 1,
    '& svg': {
      verticalAlign: 'middle'
    }
  }
})
